import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react"
import { Circle } from "@phosphor-icons/react"
import { calculatePercentage } from "functions/percentage"

interface Props {
	label: string
	value?: number | null
	total?: number | null
	color?: string
}

const ChartTooltip = ({ label, value = null, total = null, color = '' }: Props) => {
	const backgroundColor = useColorModeValue("#E2E8F0", "#171923")

	return (
	  <Flex
		padding={2}
		backgroundColor={backgroundColor}
		justifyContent="center"
		alignItems="center"
	  >
		  {
			  color && <Box mr="2"><Circle size="12px" color={color} weight="fill" /></Box>
		  }
		  <Text fontSize="md">
			  {label || null} {value && `: ${value}` || null} {value && total && `(${ Math.round(calculatePercentage(value, total)) }%)`}
		  </Text>
	  </Flex>
	)
  }

export default ChartTooltip
